import { Div } from "../div";
import { KeyboardAwareAreaProps } from "./KeyboardAwareArea.types";
export default function KeyboardAwareArea({ children }: KeyboardAwareAreaProps) {
  return <Div classNames={["flex1"]}>{children}</Div>;
}
